module.exports = __webpack_public_path__ + "img/chargingstation-alert.622c89c1.svg";